/**
 * Sidebar "Training" section — external PropWise documentation links (Gamma).
 * Each opens in a new tab. Maintain the doc list here, not in the component.
 */
export interface TrainingLink {
  /** Visible label in the sidebar */
  label: string;
  /** External documentation URL (opens in a new tab) */
  href: string;
  /** Bootstrap Icons class name, e.g. 'bi-book' */
  icon: string;
}

export const TRAINING_LINKS: readonly TrainingLink[] = [
  { label: 'Reading Your PropWise™ Results', href: 'https://propwise-results-guide-59hqjzv.gamma.site/', icon: 'bi-clipboard-data' },
  { label: 'Using PropWise™ With Buyers', href: 'https://propwise-buyers-guide-aeyooyg.gamma.site/', icon: 'bi-people' },
  { label: 'PropWise™ Onboarding Hub', href: 'https://propwise-onboarding-a1zjx0j.gamma.site/', icon: 'bi-signpost-2' },
  { label: 'PropWise™ First-Week Checklist', href: 'https://propwise-first-week-wmohhpz.gamma.site/', icon: 'bi-check2-square' },
  { label: 'PropWise™ User Guide', href: 'https://propwise-alpha-user-guid-yb91cat.gamma.site/', icon: 'bi-book' },
  { label: 'Understanding PropWise™ Cost Context', href: 'https://propwise-cost-context-ns70tg2.gamma.site/', icon: 'bi-cash-coin' },
  { label: 'Understanding PropWise™ Vendor Guidance', href: 'https://propwise-vendor-guidance-dzrepdb.gamma.site/', icon: 'bi-shop' },
  { label: 'Using PropWise™ Repair Language', href: 'https://propwise-repair-guide-zp3xk9x.gamma.site/', icon: 'bi-chat-left-text' },
] as const;
